import { Shield, Sun, Sparkles, Layers } from "lucide-react";
import { PHOTOS } from "@/lib/site";

const items = [
  { icon: Shield, title: "Perlindungan dari Sinar UV", desc: "Membantu menyaring sinar UV yang berpotensi merusak warna dan struktur material." },
  { icon: Sun, title: "Tidak Mudah Menguning", desc: "Formulasi yang menjaga kejernihan meski dipakai untuk aplikasi outdoor." },
  { icon: Sparkles, title: "Tetap Jernih dan Mengilap", desc: "Permukaan tetap halus dan reflektif, ideal untuk display premium." },
  { icon: Layers, title: "Cocok untuk Indoor & Outdoor", desc: "Fleksibel untuk berbagai kebutuhan proyek profesional." },
];

export const UVProtection = () => {
  return (
    <section id="uv" data-testid="uv-section" className="py-24 lg:py-32 bg-animax-black text-white relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-animax-yellow/10 blur-[120px]" />
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-animax-orange/10 blur-[100px]" />
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-6 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <div className="tag-uppercase text-animax-yellow mb-4">Teknologi Unggulan</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium leading-tight">
              Teknologi UV Protection untuk tampilan{" "}
              <span className="text-animax-yellow">ANIMAX Acrylic</span>
            </h2>
            <p className="mt-6 text-white/70 text-lg leading-relaxed">
              ANIMAX Acrylic dirancang untuk membantu mempertahankan kejernihan, warna, dan tampilan
              material lebih lama. Perlindungan UV menjadikannya cocok untuk signage, display,
              interior, dan aplikasi luar ruang tertentu.
            </p>

            <div className="mt-10 flex items-center gap-6">
              <div className="flex -space-x-3">
                {["#FFB800", "#FF8C00", "#FFFFFF", "#0A0A0A"].map((c, i) => (
                  <div
                    key={i}
                    className="w-10 h-10 rounded-full border-2 border-animax-black"
                    style={{ background: c }}
                  />
                ))}
              </div>
              <div>
                <div className="font-display text-2xl font-medium">4 Keunggulan Utama</div>
                <div className="text-sm text-white/60">Teruji untuk aplikasi profesional</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="relative aspect-square rounded-3xl overflow-hidden">
              <img
                src={PHOTOS.animaxProductionMachine}
                alt="Proses produksi ANIMAX Acrylic"
                className="w-full h-full object-cover opacity-75"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-animax-black via-animax-black/40 to-transparent" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative">
                  <div className="absolute inset-0 rounded-full bg-animax-yellow/30 blur-3xl animate-pulse" />
                  <div className="relative w-40 h-40 rounded-full border border-animax-yellow/40 flex items-center justify-center">
                    <div className="w-24 h-24 rounded-full border border-animax-yellow/60 flex items-center justify-center">
                      <Sun className="w-10 h-10 text-animax-yellow" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((it, i) => (
            <div
              key={i}
              data-testid={`uv-feature-${i}`}
              className="p-6 rounded-2xl border border-white/10 bg-white/5 hover:bg-white/10 hover:border-animax-yellow/30 transition-all card-lift"
            >
              <div className="w-12 h-12 rounded-xl bg-animax-yellow/20 flex items-center justify-center mb-4">
                <it.icon className="w-5 h-5 text-animax-yellow" />
              </div>
              <h4 className="font-display text-lg font-medium">{it.title}</h4>
              <p className="mt-2 text-sm text-white/60 leading-relaxed">{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
